const supported = Object.defineProperty && typeof Object.defineProperty === 'function';

export default supported;